import {
  BULLETIN_BOARD_ACCESS,
  BULLETIN_CREATE_EDIT_OWN,
  CHATBOT_ACCESS,
  EMPLOYEE_FEATURES_ACCESS,
  FORMS_ACCESS,
  FORMS_CREATE_EDIT_OWN,
  GALLERY_ACCESS,
  GALLERY_VIEW_MEDIA_ADDER_INFO,
  GALLERY_VIEW_OTHER_USERS_IMAGES,
  ORGANIZATION_CHART_VIEW,
  PROJECT_BANK_ACCESS,
  PROJECT_CHAT_ACCESS,
  PROJECT_INVITE,
  PROJECT_TIMELINES_VIEW,
  RECORDS_CREATE,
  RECORDS_SEND_TO_APPROVAL,
  UPLOAD_FILE,
  UPLOAD_PICTURE,
  VIEW_OTHERS_FILE_PERMISSIONS,
  WORK_CALENDAR_ACCESS,
} from './permissions';

export const EMPLOYEE_DEFAULT_ROLE_ITEM = {
  roleId: 'LIXANI_DEFAULT_EMPLOYEE',
  // projectId: 'LIXANI',
  // PK: 'PROJECT#LIXANI',
  // SK: 'ROLE#DEFAULT_EMPLOYEE',
  roleName: 'Työntekijä (Lixani oletus)',
  permissions: {
    [BULLETIN_BOARD_ACCESS]: true,
    [BULLETIN_CREATE_EDIT_OWN]: true,
    [CHATBOT_ACCESS]: true,
    [EMPLOYEE_FEATURES_ACCESS]: true,
    [FORMS_ACCESS]: true,
    [FORMS_CREATE_EDIT_OWN]: true,
    [GALLERY_ACCESS]: true,
    [GALLERY_VIEW_MEDIA_ADDER_INFO]: true,
    [GALLERY_VIEW_OTHER_USERS_IMAGES]: true,
    [ORGANIZATION_CHART_VIEW]: true,
    [PROJECT_BANK_ACCESS]: true,
    [PROJECT_CHAT_ACCESS]: true,
    [PROJECT_INVITE]: true,
    [PROJECT_TIMELINES_VIEW]: true,
    [RECORDS_CREATE]: true,
    [RECORDS_SEND_TO_APPROVAL]: true,
    [UPLOAD_FILE]: true,
    [UPLOAD_PICTURE]: true,
    [VIEW_OTHERS_FILE_PERMISSIONS]: true,
    [WORK_CALENDAR_ACCESS]: true,
  },
};

export const RESIDENT_DEFAULT_ROLE_ITEM = {
  roleId: 'LIXANI_DEFAULT_RESIDENT',
  // projectId: 'LIXANI',
  // PK: 'PROJECT#LIXANI',
  // SK: 'ROLE#DEFAULT_RESIDENT',
  roleName: 'Asukas (Lixani oletus)',
  permissions: {
    [BULLETIN_BOARD_ACCESS]: true,
  },
};
